export default "__VITE_ASSET__hl44jomw__"